import React, { useState, useEffect } from "react";
import "./RunningAdHeader.css";

const RunningAdHeader = () => {
  const [isPaused, setIsPaused] = useState(false);
  const [currentSpeed, setCurrentSpeed] = useState(1);
  const [gradientIndex, setGradientIndex] = useState(0);
  const [countdown, setCountdown] = useState({
    days: "05",
    hours: "12",
    minutes: "38",
    seconds: "15",
  });

  const gradients = [
    "linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 50%, #ffaaaa 100%)",
    "linear-gradient(135deg, #ff8e8e 0%, #ffaaaa 50%, #ff6b6b 100%)",
    "linear-gradient(135deg, #ff6b6b 0%, #ff5252 50%, #ff8e8e 100%)",
    "linear-gradient(135deg, #ffaaaa 0%, #ff6b6b 50%, #ff8e8e 100%)",
    "linear-gradient(135deg, #ff5252 0%, #ff6b6b 50%, #ff8e8e 100%)",
  ];

  const adItems = [
    {
      icon: "fas fa-bolt",
      text: "Flash Sale",
      highlight: "Up to 70% OFF Premium Plans",
    },
    {
      icon: "fas fa-rocket",
      text: "Launch Offer",
      highlight: "First Month Free for New Users",
    },
    {
      icon: "fas fa-gem",
      text: "Premium Features",
      highlight: "Unlimited Access to All Tools",
    },
    {
      icon: "fas fa-crown",
      text: "VIP Access",
      highlight: "Exclusive Content & Early Releases",
      glow: true,
    },
    {
      icon: "fas fa-cloud-download-alt",
      text: "Free Resources",
      highlight: "Download Templates & Assets",
    },
  ];

  const tickerItems = [
    {
      icon: "fas fa-star",
      text: "NEW FEATURE",
      highlight: "AI-Powered Analytics Dashboard",
    },
    {
      icon: "fas fa-users",
      text: "COMMUNITY",
      highlight: "Join 50,000+ Professionals",
    },
    {
      icon: "fas fa-award",
      text: "AWARD WINNING",
      highlight: "Best Design Tool 2023",
    },
    {
      icon: "fas fa-mobile-alt",
      text: "MOBILE APP",
      highlight: "Available on iOS & Android",
    },
  ];

  const features = [
    {
      icon: "fas fa-palette",
      title: "Advanced Design Tools",
      description:
        "Create stunning visuals with our intuitive design workspace. Access thousands of templates, components, and assets.",
    },
    {
      icon: "fas fa-users-cog",
      title: "Team Collaboration",
      description:
        "Work seamlessly with your team in real-time. Share projects, leave comments, and manage workflows efficiently.",
    },
    {
      icon: "fas fa-brain",
      title: "AI-Powered Features",
      description:
        "Leverage artificial intelligence to automate repetitive tasks, generate design suggestions, and optimize workflows.",
    },
    {
      icon: "fas fa-bolt",
      title: "Lightning Fast Performance",
      description:
        "Experience blazing-fast rendering and smooth interactions even with complex projects and large teams.",
    },
  ];

  const stats = [
    { value: "50K+", label: "Active Users" },
    { value: "98%", label: "Satisfaction Rate" },
    { value: "4.9", label: "Average Rating" },
    { value: "24/7", label: "Support Available" },
  ];

  // Countdown timer
  useEffect(() => {
    const updateCountdown = () => {
      const targetDate = new Date();
      targetDate.setDate(targetDate.getDate() + 5);
      targetDate.setHours(23, 59, 59, 999);

      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        setCountdown({
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00",
        });
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setCountdown({
        days: days.toString().padStart(2, "0"),
        hours: hours.toString().padStart(2, "0"),
        minutes: minutes.toString().padStart(2, "0"),
        seconds: seconds.toString().padStart(2, "0"),
      });
    };

    const interval = setInterval(updateCountdown, 1000);
    updateCountdown();

    return () => clearInterval(interval);
  }, []);

  const handlePause = () => {
    setIsPaused(!isPaused);
    const marquee = document.querySelector(".ad-marquee");
    const ticker = document.querySelector(".ticker-content");
    const progressFill = document.querySelector(".progress-fill");

    if (marquee && ticker && progressFill) {
      const playState = isPaused ? "running" : "paused";
      marquee.style.animationPlayState = playState;
      ticker.style.animationPlayState = playState;
      progressFill.style.animationPlayState = playState;
    }
  };

  const handleColorChange = () => {
    const newIndex = (gradientIndex + 1) % gradients.length;
    setGradientIndex(newIndex);
    const header = document.querySelector(".ad-header");
    if (header) {
      header.style.background = gradients[newIndex];
    }
  };

  const handleSpeedChange = () => {
    const newSpeed = currentSpeed === 1 ? 2 : currentSpeed === 2 ? 0.5 : 1;
    setCurrentSpeed(newSpeed);

    const marquee = document.querySelector(".ad-marquee");
    const ticker = document.querySelector(".ticker-content");
    const progressFill = document.querySelector(".progress-fill");

    if (marquee && ticker && progressFill) {
      marquee.style.animationDuration = `${35 / newSpeed}s`;
      ticker.style.animationDuration = `${30 / newSpeed}s`;
      progressFill.style.animationDuration = `${8 / newSpeed}s`;
    }
  };

  const handleHeaderHover = (isEntering) => {
    if (isPaused) return;

    const marquee = document.querySelector(".ad-marquee");
    const ticker = document.querySelector(".ticker-content");
    const progressFill = document.querySelector(".progress-fill");

    if (marquee && ticker && progressFill) {
      const playState = isEntering ? "paused" : "running";
      marquee.style.animationPlayState = playState;
      ticker.style.animationPlayState = playState;
      progressFill.style.animationPlayState = playState;
    }
  };

  const getSpeedText = () => {
    return currentSpeed === 1 ? "Normal" : currentSpeed === 2 ? "Fast" : "Slow";
  };

  return (
    <div>
      <div className="ad-container">
        <div
          className="ad-header"
          style={{ background: gradients[gradientIndex] }}
          onMouseEnter={() => handleHeaderHover(true)}
          onMouseLeave={() => handleHeaderHover(false)}
        >
          <div className="ad-marquee">
            {[...adItems, ...adItems.slice(0, 2)].map((item, index) => (
              <div
                key={index}
                className={`ad-item ${item.glow ? "glow-effect" : ""}`}
              >
                <div className="ad-icon">
                  <i className={item.icon}></i>
                </div>
                <div className="ad-text">
                  <span className="ad-highlight">{item.text}</span>{" "}
                  {item.highlight}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RunningAdHeader;